import React, { memo } from "react";
import { PLAYER_HEADSHOT_FALLBACK } from "../../config/constants";

const Headshot = memo(function Headshot({ src, name }) {
  return (
    <div className="h-10 w-10 shrink-0 overflow-hidden rounded-full bg-gray-100 ring-1 ring-gray-200">
      <img
        src={src || PLAYER_HEADSHOT_FALLBACK}
        alt={name || "Player"}
        className="h-full w-full object-cover object-top"
        onError={(e) => {
          if (e.currentTarget.src !== PLAYER_HEADSHOT_FALLBACK) {
            e.currentTarget.src = PLAYER_HEADSHOT_FALLBACK;
          }
        }}
        loading="lazy"
      />
    </div>
  );
});

const capitalizePosition = (position) => {
  if (!position) return "";
  return String(position).split("/")[0].split(",")[0].trim().toUpperCase();
};

export const BattingLineup = ({ lineup, teamName }) => {
  if (!lineup || lineup.length === 0) {
    return (
      <div className="text-sm text-gray-500 italic">No lineup data available</div>
    );
  }

  const grouped = {};
  lineup.forEach((player) => {
    const order = player.bat_order || 0;
    if (!grouped[order]) {
      grouped[order] = [];
    }
    grouped[order].push(player);
  });

  const sortedOrders = Object.keys(grouped).sort((a, b) => Number(a) - Number(b));

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-semibold text-gray-900 pb-2 border-b border-gray-200">{teamName}</h3>
      <div className="space-y-1">
        {sortedOrders.map((order) => {
          const players = grouped[order];
          const starter = players.find((p) => !p.is_sub);
          const subs = players.filter((p) => p.is_sub);

          return (
            <div key={order}>
              {starter && (
                <div className="flex items-center gap-3 rounded-lg border border-gray-100 bg-white py-2 px-3">
                  <div className="w-6 text-center text-sm font-semibold text-gray-400">{order}</div>
                  <Headshot src={starter.headshot_url} name={starter.player_name} />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <div className="font-medium text-gray-900 text-sm">
                        {starter.player_name || "Unknown Player"}
                      </div>
                      <span className="text-xs text-gray-500">
                        {capitalizePosition(starter.position)}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {subs.map((sub, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-3 rounded-lg border border-gray-100 bg-gray-50 py-2 px-3 ml-8"
                >
                  <div className="w-6 text-center text-sm font-semibold text-gray-400">{order}</div>
                  <Headshot src={sub.headshot_url} name={sub.player_name} />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <div className="font-medium text-gray-700 text-sm">
                        {sub.player_name || "Unknown Player"}
                      </div>
                      <span className="text-xs text-gray-500">
                        {capitalizePosition(sub.position)}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};
